import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { practicalInformationApi } from 'src/Services/API';
import { PracticalInformationDetailDto } from 'src/Services/API/generated';

export const useAddPracticalInformationAttachments = (
  options?: UseMutationOptions<
    PracticalInformationDetailDto,
    unknown,
    { practicalInformationId: string; fileIds: string[] }
  >
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<
    PracticalInformationDetailDto,
    unknown,
    { practicalInformationId: string; fileIds: string[] }
  >(
    ['add-practical-information-attachments', assetId],
    async ({ practicalInformationId, fileIds }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await practicalInformationApi.practicalInformationControllerAddAttachments(
        assetId,
        practicalInformationId,
        { fileIds }
      );
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries('fetch-all-practical-information');
        queryClient.invalidateQueries([
          'fetch-practical-information',
          assetId,
          variables.practicalInformationId,
        ]);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
